// src/components/Notification.jsx
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, XCircle, Info, TriangleAlert } from "lucide-react";

const icons = {
  success: CheckCircle2,
  failed: XCircle,
  info: Info,
  warning: TriangleAlert,
};

const colors = {
  success: "bg-green-100 text-green-800 border-green-300",
  failed: "bg-red-100 text-red-800 border-red-300",
  info: "bg-blue-100 text-blue-800 border-blue-300",
  warning: "bg-yellow-100 text-yellow-800 border-yellow-300",
};

export default function NotificationStack({ notifications, onClose }) {
  return (
    <div className="fixed top-20 sm:top-16 left-4 right-4 sm:left-auto sm:right-9 flex flex-col items-center sm:items-end gap-3 z-[9999] pointer-events-none">
      <AnimatePresence>
        {notifications.map((note) => {
          const Icon = icons[note.type] || Info;
          const colorClass = colors[note.type] || colors.info;

          return (
            <motion.div
              key={note.id}
              initial={{ opacity: 0, y: -20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.2 }}
              className={`flex items-start gap-3 p-4 rounded-xl border shadow-lg w-full max-w-[400px] sm:w-80 pointer-events-auto backdrop-blur-md bg-opacity-95 ${colorClass}`}
            >
              <Icon className="w-6 h-6 mt-1 shrink-0" />
              <div className="flex-1">
                {note.title && (
                  <h3 className="font-semibold text-sm mb-0.5">{note.title}</h3>
                )}
                <p className="text-sm">{note.message}</p>
              </div>
              <button
                onClick={() => onClose(note.id)}
                className="ml-2 text-gray-500 hover:text-gray-700 transition"
              >
                ✕
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
